import packageInfo from '../../package.json';

function Footer() {
  return <p class='text-light float-right'>v{packageInfo.version}</p>;
};

export default Footer;
